
export function getInstance(method, path, body = '') {

    let localStorageItem = (localStorage.getItem('bgToken'))
  
    const configDetails = localStorageItem
    
    const config = generateSignature(configDetails, method, path, body)
    return config
  }
  
  function generateSignature(configDetails, method, path, payload, contentType = 'application/json') {
  
    const host = process.env.REACT_APP_API_URL
  
    if (!configDetails) return null
    const jwtOptions = {
      method,
      url: `${host}${path}`,
      
    }
    
    if (payload || method === 'POST' || method === 'GET' || method === 'DELETE' || method === 'PUT') {
      jwtOptions.data = payload
      jwtOptions.headers = jwtOptions.headers || {}
      jwtOptions.headers['Content-Type'] = contentType
      jwtOptions.headers['Accept'] = 'application/json'
      jwtOptions.headers['X-Access-Token'] = configDetails
    }
    return jwtOptions
  }

  export function getInstancePublic(method, path, body = '') {

    // let localStorageItem = (localStorage.getItem('bgToken'))
    const host = process.env.REACT_APP_API_URL

    const options = {
      method,
      url: `${host}${path}`,
      
    }

    if (body || method === 'POST' || method === 'GET' || method === 'DELETE' || method === 'PUT') {
      options.data = body
      options.headers = options.headers || {}
      options.headers['Content-Type'] = 'application/json'
      options.headers['Accept'] = 'application/json'
    }
    return options
  }